var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toast',{attrs:{"position":"top-right"}}),_c('Toast',{attrs:{"group":"error","position":"top-center"}}),(_vm.needDefaultLayout)?_c('default-layout'):_c('empty-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }